// @flow
const $ = require('jquery');

/* Grid layout (ve stylu Pinterest, ale se zachovanim poradi prvku) */
const PLUGIN_NAME = 'gridLayout';
const DEFAULTS = {
	itemElement:    '.item',			// selektor tridy polozky layoutu
	debugMode:      false,				// zapnout/vypnout debug mod
	timestampedLog: false,				// zapnuti/vypnuti casovych znacek v debug modu
};

function GridLayout(element, options) {
	this.element = element;

	this.options = $.extend({}, DEFAULTS, options);
	this.defaults = DEFAULTS;
	this.name = PLUGIN_NAME;

	this.init();
}

/**
 * Inicializace pluginu
 *  @return    void
 */
GridLayout.prototype.init = function init() {
	const fn = this;

	fn.log(`Iniciace pluginu ${fn.name}`);

	// nacteni ostatnich potrebnych hodnot do pole options
	fn.options.me = $(fn.element);
	fn.options.items = fn.options.me.find(fn.options.itemElement);

	fn.getDimensions();
	fn.createGrid();
};

/**
 *  Provedeni zapisu do konzole, pokud je zapnuty debug mod
 *  @param    str        retezec, ktery se vypise v konzoli
 *  @return    void
 */
GridLayout.prototype.log = function log(str) {
	const fn = this;
	if (fn.options.debugMode) {
		str = `${fn.name} > ${str}`;
		if (fn.options.timestampedLog) {
			const now = new Date();
			str = `${now.toLocaleTimeString()}.${now.getMilliseconds()} > ${str}`;
		}
		if (window.console) {
			console.log(str);
		} else {
			if ($(fn.element).find('.console').length === 0) {
				$(fn.element).append('<div class=\'console\'></div>');
			}
			$(fn.element).find('.console').append(`<p>${str}</p>`);
		}
	}
};

GridLayout.prototype.getDimensions = function getDimensions() {
	const fn = this;
	fn.log('GET DIM: getDimensions()');

	fn.options.gridWidth = fn.options.me.width();
	fn.options.itemWidth = fn.options.items.outerWidth(false);
	fn.options.fullItemWidth = fn.options.items.outerWidth(true);
	fn.options.hMargin = fn.options.fullItemWidth - fn.options.itemWidth;
	fn.options.columns = Math.floor(fn.options.gridWidth / fn.options.fullItemWidth);
};

GridLayout.prototype.createGrid = function createGrid() {
	const fn = this;
	let cTop = 0;
	let cLeft = 0;
	let columnIndex = 0;
	const lastRow = [];
	const columnHeight = [];
	let isFirstRow = true;
	fn.log('CREATE GRID: cerateGrid()');

	fn.options.items.each((index, element) => {
		const $currentElement = $(element);
		columnIndex = index % fn.options.columns;
		cLeft = columnIndex * fn.options.fullItemWidth;

		if (lastRow.length === fn.options.columns) {
			isFirstRow = false;
			cTop = parseInt(lastRow[ columnIndex ].css('top')) + lastRow[ columnIndex ].outerHeight(true);
		}
		fn.log(`CREATE GRID: cLeft=${cLeft}`);
		fn.log(`CREATE GRID: cTop=${cTop}`);

		$currentElement.css({
			position: 'absolute',
			top:      cTop,
			left:     cLeft,
		});
		lastRow[ columnIndex ] = $currentElement;

		columnHeight[ columnIndex ] = isFirstRow ?
				$currentElement.outerHeight(true) :
				columnHeight[ columnIndex ] + $currentElement.outerHeight(true);
	});

	fn.options.me.css('position', 'relative').height(Math.max.apply(null, columnHeight));
};

/**
 * "public" API
 */
const API = { resize: GridLayout.prototype.init };

$.fn[ PLUGIN_NAME ] = function plugin(options) {
	const args = arguments;
	return this.each((index, element) => {
		const $this = $(element);

		// get plugin instance
		let plugin = $this.data(`plugin_${PLUGIN_NAME}`);

		// ...or create new
		if (!plugin) {
			plugin = new GridLayout(this, options);
			$this.data(this, `plugin_${PLUGIN_NAME}`, plugin);
		} else if (API[ options ]) {
			// if there is and first parameter is in predefined API methods, call it with rest of params
			API[ options ].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.gridLayout.js